import React, { useEffect, useState } from "react";
import styled from "styled-components";
// import { Container } from "../../../Components/StyledComponents/StyledComponents";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import axios from "axios";
import environmentVariables from "../../../config/environmentVariables";
import { useParams } from "react-router";
const Root = styled.div`
  margin: 70px 0;
  @media (max-width: 1024px) {
    margin: 0;
  }
`;
const Container = styled.div`
  width: 95%;
  margin: 0 auto;
  padding: 0 9.6rem;
  @media (max-width: 1740px) {
    width: 100%;
    margin: 0 auto;
    padding: 0 100px;
  }
  @media (max-width: 1260px) {
    padding: 0 5rem;
  }
  @media (max-width: 1024px) {
    padding: 0 2rem;
  }
  @media (max-width: 768px) {
    padding: 0 0.5rem !important;
  }
`;

const BidingTableContainer = styled(Container)``;
const TextWrapper = styled.div`
  margin: 10px 0;
`;
const Text = styled.text`
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  font-size: 24px;
  color: #ffffff;

  width: 80%;
  @media (max-width: 650px) {
    font-size: 24px;
  }
  @media (max-width: 425px) {
    /* font-size:13px; */
  }
`;

const TableWrapper = styled.div`
  margin: 30px 0;
  @media (max-width: 768px) {
    overflow-x: scroll;
  }
`;
const HeadingWrapper = styled.div`
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  text-align: start;
  padding: 20px 20px;
  background-color: #ebebeb;

  @media (max-width: 768px) {
    width: 800px;
  }

  @media (max-width: 650px) {
    padding: 10px 0px 10px 10px;
    /* grid-template-columns: 14% 15% 24% 24% 23%; */
  }
`;
const HeadingText = styled.text`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #000;
  font-family: sans-serif;
  @media (max-width: 425px) {
    font-size: 13px;
  }
`;
const TableContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  margin: 20px 0;
  /* background: linear-gradient(
    180deg,
    rgba(249, 249, 249, 0.016) 0%,
    rgba(255, 255, 255, 0.072) 100%,
    rgba(249, 249, 249, 0.016) 100%
  ); */
  border-radius: 10px;
  padding: 10px 20px;
  @media (max-width: 768px) {
    overflow-y: scroll;
    width: 800px;
  }
  @media (max-width: 650px) {
    padding: 10px 0px 10px 10px;
    /* grid-template-columns: 14% 15% 24% 24% 23%; */
  }
`;
const TableValueImageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Wrapper = styled.div`
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  @media (max-width: 1024px) {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
`;
const TableInnerWrapper = styled(Wrapper)``;
const Imagewrapper = styled.div``;
const Image = styled.img``;
const TableContent = styled.div`
  font-family: sans-serif;
  @media (max-width: 425px) {
    font-size: 13px;
  }
`;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  /* flex-direction: column; */
  justify-content: flex-end;
`;

const ToggleLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-right: 10px;
  border-radius: 10px;
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  border-radius: 10px;

  &:checked + span {
    background-color: #2196f3;
    border-radius: 10px;
  }

  &:checked + span:before {
    transform: translateX(20px);
    border-radius: 10px;
  }
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 10px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 10px;
  }
`;

const Span = styled.span`
  font-size: 22px;
`;
const ToggleInputTextWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  width: 80%;
  margin: 10px 10px 30px 0px;
`;

const ActivityTableComponent = ({ loadingActivityAndHistory }) => {
  const params = useParams();
  const [isChecked, setIsChecked] = useState(false);
  const [tradeListNew, setTradeListNew] = useState([]);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [tradeList, setTradeList] = useState([]);
  const [divArray, setDivArray] = useState([]);
  useEffect(() => {
    if (tradeList && tradeList.length > 0) {
      const totalPages = Math.ceil(tradeList.length / 10);
      const arr = Array.from({ length: totalPages }, (_, index) => index + 1);
      setDivArray(arr);
      const newtradelist = tradeList.sort((a, b) => b?.["time"] - a?.["time"]);
      setTradeListNew(
        newtradelist.slice((pageNumber - 1) * 10, (pageNumber - 1) * 10 + 10)
      );
    }
  }, [tradeList, pageNumber]);
  useEffect(() => {
    getHistoryData();
  }, []);
  const getHistoryData = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/gethistory/${params.contract}/${params.tokenId}`
      )
      .then((res) => {
        if (res?.data) {
          setTradeList(res?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function getTimeAgo(createdAt) {
    const currentDate = new Date();
    const transactionDate = new Date(createdAt); // converting to milliseconds

    const timeDifference = Math.floor((currentDate - transactionDate) / 1000);

    if (timeDifference < 60) {
      return `${timeDifference} seconds ago`;
    } else if (timeDifference < 3600) {
      const minutes = Math.floor(timeDifference / 60);
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else if (timeDifference < 86400) {
      const hours = Math.floor(timeDifference / 3600);
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else {
      const day = transactionDate.getDate();
      const month = transactionDate.getMonth() + 1;
      const year = transactionDate.getFullYear();
      return `${day}-${month}-${year}`;
    }
  }

  // const getCurrencyName = (currency) => {
  //   let currencyObj = {
  //     "0x32522357a30E2F5b685eE90014f63A47DF1F9577": "LORD",
  //     "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6": "MLD",
  //     "0xc2132D05D31c914a87C6611C10748AEb04B58e8F": "USDT",
  //   };
  //   return currencyObj[`${currency}`] ? currencyObj[`${currency}`] : `Matic`;
  // };
  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  return loadingActivityAndHistory == true ? (
    <>
      <div
        style={{ display: "flex", justifyContent: "center", height: "100px" }}
      >
        <CircularLoader />
      </div>
    </>
  ) : (
    <Root>
      {/* {tradeListNew && tradeListNew.length > 0 ? (
        <ActivityTableGraph nftData={tradeListNew} />
      ) : (
        <></>
      )} */}
      <Container>
        <TextWrapper>
          <Text>Activity and History</Text>
        </TextWrapper>
        <TableWrapper>
          <HeadingWrapper>
            <Wrapper>
              <HeadingText>From</HeadingText>
            </Wrapper>
            <Wrapper>
              <HeadingText>To </HeadingText>
            </Wrapper>
            <Wrapper>
              <HeadingText>Price</HeadingText>
            </Wrapper>
            <Wrapper>
              <HeadingText> Currency</HeadingText>
            </Wrapper>

            <Wrapper>
              <HeadingText>Time</HeadingText>
            </Wrapper>
          </HeadingWrapper>
          {tradeListNew && tradeListNew?.length > 0 ? (
            tradeListNew?.map((trade, i) => {
              return (
                <TableContentWrapper key={i}>
                  <TableInnerWrapper>
                    <TableContent>
                      {`${trade?.["from"]?.slice(0, 6)}...${trade?.[
                        "from"
                      ]?.slice(-6)}` || ""}
                    </TableContent>
                  </TableInnerWrapper>
                  <TableInnerWrapper>
                    <TableContent>
                      {`${trade?.["to"]?.slice(0, 6)}...${trade?.["to"].slice(
                        -6
                      )}` || ""}
                    </TableContent>
                  </TableInnerWrapper>
                  <TableInnerWrapper>
                    <TableContent>
                      {" "}
                      {parseFloat(trade?.["price"]) || "0"}
                    </TableContent>
                  </TableInnerWrapper>
                  <TableInnerWrapper>
                    <TableValueImageWrapper>
                      <TableContent>{trade?.["currency"]}</TableContent>
                    </TableValueImageWrapper>
                  </TableInnerWrapper>

                  <TableInnerWrapper>
                    <TableContent>
                      {" "}
                      {getTimeAgo(trade?.["createdAt"])}
                    </TableContent>
                  </TableInnerWrapper>
                </TableContentWrapper>
              );
            })
          ) : (
            <>
              <div style={{ margin: "20px 0", textAlign: "center" }}>
                No History Available
              </div>
            </>
          )}
        </TableWrapper>
        {/* <ToggleContainer>
        {divArray &&
          divArray.length > 0 &&
          divArray.map((val, index) => (
            <div
              style={{
                border: "1px solid white",
                padding: "10px",
                borderRadius: "10px",
                color: pageNumber == index + 1 ? "black" : "white",
                backgroundColor: pageNumber == index + 1 ? "white" : "black",
                cursor: "pointer",
              }}
              onClick={() => setPageNumber(index + 1)}
            >
              {index + 1}
            </div>
          ))}
      </ToggleContainer> */}
        {divArray && divArray.length > 1 && (
          <>
            <ToggleContainer>
              {divArray &&
                divArray.length > 0 &&
                divArray.map((val, index) => {
                  // Determine whether to show the current div based on the condition
                  const showDiv =
                    index === 0 ||
                    index === divArray.length - 1 || // First and last indices always shown
                    index === pageNumber - 1 || // Current page number shown
                    Math.abs(index - (pageNumber - 1)) <= 1; // Left and right indices of current page shown

                  if (showDiv) {
                    return (
                      <div
                        key={index}
                        style={{
                          border: "1px solid white",
                          padding: "10px",
                          borderRadius: "10px",
                          color: pageNumber === index + 1 ? "black" : "white",
                          backgroundColor:
                            pageNumber === index + 1 ? "white" : "black",
                          cursor: "pointer",
                        }}
                        onClick={() => setPageNumber(index + 1)}
                      >
                        {index + 1}
                      </div>
                    );
                  } else if (
                    (index === 1 && pageNumber > 3) ||
                    (index === divArray.length - 2 &&
                      pageNumber < divArray.length - 2)
                  ) {
                    // Show "..." when there is a gap more than 1 between two indices
                    return (
                      <>
                        {" "}
                        <div
                          key={index}
                          style={{
                            border: "none",
                            padding: "0px",
                            cursor: "default",
                            color: "white",
                          }}
                        >
                          .
                        </div>
                        <div
                          key={index}
                          style={{
                            border: "none",
                            padding: "0px",
                            cursor: "default",
                            color: "white",
                          }}
                        >
                          .
                        </div>
                        <div
                          key={index}
                          style={{
                            border: "none",
                            padding: "0px",
                            cursor: "default",
                            color: "white",
                          }}
                        >
                          .
                        </div>
                      </>
                    );
                  }
                  return null; // Hide the div
                })}
            </ToggleContainer>
          </>
        )}
      </Container>
    </Root>
  );
};

export default ActivityTableComponent;
